export type SortOption = {
    id: string,
    showOrientationToggler: boolean,
    defaultOrientation: string,
    label: string
};

export interface Sorting {
    options: SortOption[],
    sortBy: string,
    selectedOption: SortOption
}

export const ORIENTATION_OPTIONS = {
    BOTTOM_TO_TOP: 'bottomToTop',
    TOP_TO_BOTTOM: 'topToBottom'
};

